export default {
  getUserId (state, id) {
    if (id) {
      state.userId = id
    } else {
      state.userId = window.truckLogin.uid
    }
  },
  setState (state, send) {
    state[send[0]] = send[1]
  },
  getDevice (state) {
    const uaCase = navigator.userAgent
    if (/MicroMessenger/i.test(navigator.userAgent)) {
      state.deviceType = 'weixin'
    } else if (uaCase.toLowerCase().indexOf('360che') >= 0) {
      state.deviceType = 'app'
    } else if (uaCase.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    ) {
      state.deviceType = 'm'
    } else {
      state.deviceType = 'pc'
    }
  },
  getShareStatus (state, status) {
    state.shareStatus = status
  }
}
